export default __webpack_public_path__ + "static/icecream-38043773f2c781047efd847c97a80415.png";